import React, { Component } from "react";
import { Switch, Route } from 'react-router-dom';  // Enables routing between the components
import { ServiceRequestContext } from '../index';

import UserNotAuthorized from '../components/EnsembleComponents/Common/UserNotAuthorized';

// Updated  Facility Management Components
import FacilityMaintenanceLayout from 'components/FacilityRequestComponents/FacilityMaintenanceLayout';
import FacilityMaintenanceLogin from '../components/FacilityRequestComponents/Login/Login';
import FacilityManagementLogout from '../components/Logout/FaciltyMgmntLogout';



// Ensemble Components

import ManageTenant from '../components/EnsembleComponents/TenantComponents/ManageTenants/ManageTenants';
import EnsembleLogin from '../components/EnsembleComponents/Common/Login/EnsembleLogin';
import Forbidden from '../components/EnsembleComponents/Common/Login/Forbidden';
import TimeCustomization from '../components/EnsembleComponents/Common/Layouts/Widgets/TimeCustomization';
import ViewIndividualTenantManage from '../components/EnsembleComponents/TenantComponents/TenantMain/ViewIndividualTenantMain';
import CreateNewTenantManage from '../components/EnsembleComponents/TenantComponents/TenantMain/CreateNewTenantMain';
import EditCompnayInfo from '../components/EnsembleComponents/TenantComponents/ManageTenants/Tenants/EditTenant/EditCompanyInformation';
import EditHoursofOperation from '../components/EnsembleComponents/TenantComponents/ManageTenants/Tenants/EditTenant/EditNormalHours';
import InvoicesLayout from '../components/EnsembleComponents/TenantComponents/TenantMain/InvoicesMain';

import LicenseAgreement from '../components/common/Modals/AcceptLicenseTerms';


// BACNetSC Components
import ManageBacnet from '../components/EnsembleComponents/BACNetComponents/_ModalForms/ManageSecureConnect';
import ManageSignCertificate from '../components/EnsembleComponents/BACNetComponents/_ModalForms/ManageSignCertificate';
import ViewSecureConnectedDevices from '../components/EnsembleComponents/BACNetComponents/_ModalForms/ViewSecureConnectedDevices';
import ViewHubParameters from '../components/EnsembleComponents/BACNetComponents/_ModalForms/ViewHubParameters';

// WorkOrder Components
import ManageWorkOrder from '../components/EnsembleComponents/WorkOrderComponents/Workorder';
import ManageASU from '../components/EnsembleComponents/ASUComponents/ASU';
import ServiceRequest from '../components/EnsembleComponents/WorkOrderComponents/RequestServiceComponents/RequestServiceLayout';
import RequestServiceErrorHandling from '../components/EnsembleComponents/WorkOrderComponents/RequestServiceComponents/RequestServiceErrorHandling';

//PreventativeMaintenance Components
import ManagePreventativeMaintenance from '../components/EnsembleComponents/WorkOrderComponents/PreventativeMaintenance';

// Report Management Components
import ManageReports from '../components/EnsembleComponents/ReportsManagement/ManageReportsLayout';

// Dashboard Components
import DashboardLayout from '../components/EnsembleComponents/Home/Dashboard';

// Administration Components
import AdministrationLayout from '../components/EnsembleComponents/Home/Administration';

// Logout Component
import Logout from '../components/Logout/Logout';
import SingleSignOut from '../components/EnsembleComponents/Common/Login/SingleSignOn';
import PropertyManagerLogout from '../components/Logout/PropertyManagerLogout';

//Error Component
import GlobalError from '../components/EnsembleComponents/Common/GlobalErrorPage';

import WorkOrderWrapper from '../components/EnsembleComponents/WorkOrderComponents/WorkOrderWrapper';
import PrevenatativeMaintenanceWrapper from '../components/EnsembleComponents/WorkOrderComponents/PreventativeMaintenanceWrapper';
import Wrapper from '../components/EnsembleComponents/WorkOrderComponents/EquipmentWrapper';
import AlarmWrapper from '../components/EnsembleComponents/WorkOrderComponents/AlarmWrapper';
import { userIsTenantEmployeeRedir,userIsPropertyManagerRedir } from "../action/authentication/auth";
import EventMarkerHome from "components/EnsembleComponents/ReportsManagement/EventMarker/EventMarkerHome";
import ManageSiteLicense from "components/EnsembleComponents/Common/Administration/Licensing/ManageSiteLicense";

// Need to apply the hocs here to avoid applying them inside the render method
//  const tenant_employee_Login = userIsNotAuthenticatedRedir(LoginComponent)
// const Protected = userIsAuthenticatedRedir(ProtectedComponent)
// const Admin = userIsAuthenticatedRedir(userIsAdminRedir(AdminComponent))

import EquipmentList from "components/EnsembleComponents/EquipmentList";
import DashboardHome from "components/EnsembleComponents/ReportsManagement/Dashboard/DashboardHome";
import Dashboard2Home from "components/EnsembleComponents/ReportsManagement/Dashboard2/Dashboard2Home";
import InvalidLogEntry from "components/EnsembleComponents/Common/Administration/TechnicianHelpScreen/InvalidLogEntry";

export default class RouterComponent extends Component {
    render() {
        return (
            <div role="main" style={{height: "100%"}}>
                <Switch>
                {/* Facility Management Routing */}
                <Route exact path="/UserNotAuthorized" component={UserNotAuthorized}/>
                <Route exact path="/facilitylogin" component={FacilityMaintenanceLogin}/>
                <Route path='/FacilityManagement/:component' component={userIsTenantEmployeeRedir(FacilityMaintenanceLayout)}/> 
                <Route exact path="/FacilityManagementLogout" component={FacilityManagementLogout}/>               


                <Route exact path="/sso" component={SingleSignOut}/>
                <Route exact path="/Logout" component={Logout}/>
                <Route exact path="/PropertyMangerLogout" component={PropertyManagerLogout}/>
                
                {/* SystemAdministrator */}
                <Route exact path="/SystemAdmin/InvalidLoginLog" component={InvalidLogEntry}/>

                {/* Ensemble Routing */}
                <Route exact path="/" component={EnsembleLogin}/>
				<Route exact path="/index.html" component={EnsembleLogin}/>
                <Route exact path="/ensemblelogin" component={EnsembleLogin}/>
                <Route exact path="/forbidden" component={Forbidden}/>
                
                <Route exact path="/LicenseAgreement" component={LicenseAgreement}/>
                <Route exact path="/managetenant" component={userIsPropertyManagerRedir(ManageTenant)}/>
                <Route exact path="/TimeCustomization" component={userIsPropertyManagerRedir(TimeCustomization)}/>
                <Route exact path="/ViewIndividualTenantManage" component={userIsPropertyManagerRedir(ViewIndividualTenantManage)}/>
                <Route exact path="/EditCompnayInfo" component={userIsPropertyManagerRedir(EditCompnayInfo)}/>
                <Route exact path="/EditNormalHours" component={userIsPropertyManagerRedir(EditHoursofOperation)}/>
                <Route exact path="/NewTenant" component={userIsPropertyManagerRedir(CreateNewTenantManage)}/>
                <Route exact path="/managetenant/:component" component={userIsPropertyManagerRedir(CreateNewTenantManage)}/>

                <Route exact path="/Invoices" component={userIsPropertyManagerRedir(InvoicesLayout)}/>
                <Route exact path="/Invoices/:component" component={userIsPropertyManagerRedir(InvoicesLayout)}/>

                {/* Dashboard Routing */}
                <Route exact path="/Dashboard" component={DashboardHome}/>
                <Route exact path="/Dashboard2" component={Dashboard2Home}/>
                <Route exact path="/Dashboard/:component" component={DashboardLayout}/>
                <Route path='/Graphics/Dashboards/:dashName' component={DashboardLayout}/>

                  {/* Administration Routing */}
                <Route exact path="/SystemAdmin" component={userIsPropertyManagerRedir(AdministrationLayout)}/>
                <Route exact path="/SystemAdmin/:component" component={userIsPropertyManagerRedir(AdministrationLayout)}/>

                {/* Work Order Routing */}
                <Route exact path="/ManageWorkOrder" component={userIsPropertyManagerRedir(ManageWorkOrder)} />
                <Route exact path="/ManageASU" component={userIsPropertyManagerRedir(ManageASU)} />
                <Route exact path="/ManagePreventativeMaintenance" component={userIsPropertyManagerRedir(ManagePreventativeMaintenance)} />
			
                {/*Reports Management Routing */}
                <Route exact path="/ManageReports" component={ManageReports}/>
                <Route path='/ManageReports/:component' component={ManageReports}/>               
                
                <Route exact path="/Logout" component={Logout}/>
                <Route exact path="/EventMarker" component={EventMarkerHome} />
                <Route exact path="/GlobalError" component={GlobalError}/>

                <Route exact path="/EquipmentWO" component={WorkOrderWrapper} />
                <Route exact path="/EquipmentPM" component={PrevenatativeMaintenanceWrapper} />
                <Route exact path="/EquipmentWrapper" component={Wrapper} />
                
                {/* BACnet Secure Connect*/}
                <Route exact path="/ManageBACNet" component={ManageBacnet} />
                <Route exact path="/ManageSignCertificate" component={ManageSignCertificate} />
                <Route exact path="/ConnectedNodeDevices/:name" component={ViewSecureConnectedDevices} />
                <Route exact path="/ViewHubParameters" component={ViewHubParameters} />

                <Route exact path="/AlarmWrapper"><AlarmWrapper ref={(AlarmWrapper) => {window.AlarmWrapper = AlarmWrapper}} /></Route>
                <Route exact path="/EquipmentList" component={EquipmentList} />
                <Route exact path="/ManageSiteLicense" component={ManageSiteLicense} />
                <ServiceRequestContext.Consumer>
                { ({HasWOFormAccess,ServiceRequestDetails}) => {
                       if(ServiceRequestDetails !== null){
                        const isServiceRequestEnabled = ServiceRequestDetails.length ? ServiceRequestDetails[0].isServiceRequestEnabled : false;                   
                        return (HasWOFormAccess && isServiceRequestEnabled)? 
                         <Route exact path='/ServiceRequest' component={ServiceRequest} />
                         : <Route exact path='/ServiceRequest' component={RequestServiceErrorHandling} />
                       }
                }}
                </ServiceRequestContext.Consumer>
                <Route component={UserNotAuthorized} />
             </Switch>           
            </div>
        );
    }
}


